import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirConcludedJob } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirLastConcludedJobsAdapter = createEntityAdapter<JSONApiDataObject<BsdirConcludedJob>>({
  selectId: item => item.id
});

export const bsdirLastConcludedJobsSlice = createSlice({
  name: 'bsdirLastConcludedJobs',
  initialState: bsdirLastConcludedJobsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirConcludedJob>),
  reducers: {
    bsdirLastConcludedJobsAdded: (state, action) => {
      bsdirLastConcludedJobsAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirLastConcludedJobsSelectors = bsdirLastConcludedJobsAdapter.getSelectors(
  (state: RootState) => state.bsdir.lastConcludedJobs);
export default bsdirLastConcludedJobsSlice.reducer;
